export const handleDuplicateFile = (text, pathName, files, toggleShowDuplicateFileRow) => {
    if (text?.includes("Problem saving data: UserFile already exists for Document upload associated with GUID: ")) {
        toggleShowDuplicateFileRow(true, pathName, files);
    }
}